/**
 * Fetches the current featured image for a Shopify product by handle.
 *
 * Hits the public `/products/<handle>.js` endpoint on the live storefront, so
 * whenever Maria swaps a product photo in Shopify the quiz picks up the new
 * image on the next load - no redeploy, no hardcoded CDN URL to keep in sync.
 *
 * Returns null if the product can't be resolved; callers fall back to the
 * static URL baked into products.ts.
 */
const STOREFRONT_ORIGIN = 'https://nobodysprincess.com'

const cache = new Map<string, Promise<string | null>>()

export function fetchProductImage(handle: string): Promise<string | null> {
  if (!handle) return Promise.resolve(null)
  const cached = cache.get(handle)
  if (cached) return cached

  const promise = fetch(`${STOREFRONT_ORIGIN}/products/${handle}.js`, { credentials: 'omit' })
    .then(r => (r.ok ? r.json() : null))
    .then((data: { featured_image?: string } | null) => {
      if (!data?.featured_image) return null
      return data.featured_image.startsWith('//') ? `https:${data.featured_image}` : data.featured_image
    })
    .catch(() => null)

  cache.set(handle, promise)
  return promise
}
